
export default {
  name: 'OrderingTable',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headings() {
      if (!Array.isArray(this.list) && this.list?.length === 0) return false
      return Object.keys(this.list?.[0] || {}).reduce(
        (previousValue, currentValue) => {
          previousValue[`${currentValue}`] = this.$t(
            `front.ordering.${currentValue}`,
          )

          return previousValue
        },
        {},
      )
    },
  },
}
